<template>
    <a-modal
        :title="Object.keys(record).length ? $t('hotel.edit_common_commodity' /* 编辑常用商品*/) : $t('hotel.add_common_commodity' /* 新增常用商品*/)"
        :visible="visible"
        :width="'70%'"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <a-spin tip="Loading..." :spinning="loading">
            <a-form :form="form">
                <div class="flex form-box">
                    <div class="flex-item mr15">
                        <a-form-item class="mb15 mt15" :label="$t('hotel.tax_classification_code' /* 税收分类编码*/)">
                            <div class="flex">
                                <div class="flex-item">
                                    <a-input
                                        v-decorator="[
                                            'tax_classification_code',
                                            {
                                                rules: [{ required: true, message: $t('hotel.select_tax_classification_code' /* 请选择税收分类编码*/) }]
                                            }
                                        ]"
                                        disabled
                                        :placeholder="$t('hotel.select_tax_classification_code' /* 请选择税收分类编码*/)"
                                    />
                                </div>
                                <div>
                                    <a-button class="ml10" type="primary" @click="handelSearch">{{ $t('hotel.click_search' /* 点击搜索*/) }}</a-button>
                                </div>
                            </div>
                        </a-form-item>
                        <a-form-item class="mb15" :label="$t('hotel.specification_model' /* 规格型号*/)">
                            <a-input v-decorator="['specification_model']" :placeholder="$t('hotel.enter_tax_specification_model' /* 请输入税收规格型号*/)" />
                        </a-form-item>
                        <a-form-item class="mb15" :label="$t('hotel.unit_price' /* 单价*/)">
                            <a-input v-decorator="['price']" :placeholder="$t('hotel.enter_unit_price' /* 请输入单价*/)" />
                        </a-form-item>
                        <a-form-item class="mb15" :label="$t('hotel.tax_rate' /* 税率*/)">
                            <a-select
                                v-decorator="['tax_rate_id', { rules: [{ required: true, message: $t('hotel.select_tax_rate' /* 请选择税率*/) }] }]"
                                :placeholder="$t('hotel.select_tax_rate' /* 请选择税率*/)"
                                style="width: 100%"
                                allowClear
                            >
                                <a-select-option v-for="item in taxList" :key="item.id" :value="item.id">{{ item.store_name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="flex-item">
                        <a-form-item class="mb15 mt15" :label="$t('hotel.tax_classification_name' /* 税收分类名称*/)">
                            <a-input
                                v-decorator="[
                                    'tax_classification_name',
                                    {
                                        rules: [{ required: true, message: $t('hotel.enter_tax_classification_name' /* 请输入税收分类名称*/) }]
                                    }
                                ]"
                                disabled
                                :placeholder="$t('hotel.enter_tax_classification_name' /* 请输入税收分类名称*/)"
                            />
                        </a-form-item>
                        <a-form-item class="mb15" :label="$t('hotel.product_name' /* 商品名称*/)">
                            <a-input
                                v-decorator="['product_name', { rules: [{ required: true, message: $t('hotel.enter_product_name' /* 请输入商品名称*/) }] }]"
                                :placeholder="$t('hotel.enter_product_name' /* 请输入商品名称*/)"
                            />
                        </a-form-item>
                        <a-form-item class="mb15" :label="$t('hotel.metering_unit' /* 计量单位*/)">
                            <a-input v-decorator="['metering_unit']" :placeholder="$t('hotel.enter_metering_unit' /* 请输入计量单位*/)" />
                        </a-form-item>

                        <a-form-item class="mb15" label="" :hidden="true">
                            <a-input v-decorator="['short_name']" :placeholder="$t('hotel.enter_product_name' /* 请输入商品名称*/)" />
                        </a-form-item>
                        <a-form-item class="mb15" label="" :hidden="true">
                            <a-input v-decorator="['tax_category_tax_rate']" :placeholder="$t('hotel.enter_product_name' /* 请输入商品名称*/)" />
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </a-spin>
        <tree-classify ref="treeClassify" @handleSelect="handleSelect" />
    </a-modal>
</template>

<script>
import pick from 'lodash.pick';
import treeClassify from './tree-classify.vue';
const fields = ['tax_classification_code', 'specification_model', 'price', 'tax_classification_name', 'product_name', 'metering_unit', 'tax_rate_id', 'short_name', 'tax_category_tax_rate'];
export default {
    name: 'InvoiceParams',
    components: { treeClassify },
    props: {
        channel_id: String
    },
    data() {
        return {
            fields,
            visible: false,
            loading: false,
            form: this.$form.createForm(this),
            labelCol: { xs: 12, md: 12, lg: 6 },
            wrapperCol: { xs: 12, md: 16, lg: 16 },
            taxList: [],
            record: {}
        };
    },
    methods: {
        // 选中 子组件传过来的数据
        handleSelect(item) {
            console.log(item, 'item');
            fields.forEach(v => this.form.getFieldDecorator(v));
            this.form.setFieldsValue({
                tax_classification_code: item.category_id,
                tax_classification_name: item.goods_name,
                product_name: item.goods_name,
                short_name: item.short_name,
                tax_category_tax_rate: item.tax_rate_desc
            });
        },
        handelSearch() {
            this.$refs.treeClassify.show();
        },
        // 税率接口
        getInvoiceTaxList() {
            let data = {
                channel_id: this.channel_id
            };
            this.$request.get({ url: 'getInvoiceTaxList', data }).then(res => {
                this.taxList = res.data;
            });
        },
        getInvoiceProductDetail(record) {
            this.$request
                .get({
                    url: 'getInvoiceProductDetail',
                    data: {
                        product_id: record.id,
                        channel_id: this.channel_id
                    }
                })
                .then(res => {
                    this.form.setFieldsValue(pick(res.data, fields));
                });
        },
        show(record) {
            this.record = {};
            fields.forEach(v => this.form.getFieldDecorator(v));
            this.visible = true;
            this.getInvoiceTaxList();
            if (record) {
                this.getInvoiceProductDetail(record);
                this.record = record;
            }
        },

        handleOk() {
            // 获取表单
            this.form.validateFields((err, values) => {
                if (!err) {
                    let data = {
                        channel_id: this.channel_id,
                        ...values
                    };
                    if (Object.keys(this.record).length) data.product_id = this.record.id;
                    this.$request
                        .post({
                            url: Object.keys(this.record).length ? 'editInvoiceProduct' : 'addInvoiceProduct',
                            data
                        })
                        .then(res => {
                            if (res.code == 200) {
                                this.$message.success(this.$t('formConfig.save_success' /* 保存成功*/));
                                this.$emit('ok');
                                this.handleCancel();
                            }
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    }
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
    .form-box {
        flex-direction: column;
    }
}
</style>
